<template>
  <el-row class="container">
    <el-col :span="24" class="header">
      <el-col :span="10" class="logo" :class="collapsed?'logo-collapse':'logo-expand'">
        <!--<template v-if="!collapsed">{{sysName}}</template>-->
        <!--刘总说的加logo2021-11-19-->
        <template v-if="!collapsed"><img src="../../../static/img/logo.png" alt="" class="logo"></template>
      </el-col>
      <el-col :span="10">
        <div class="tools" @click.prevent="collapse">
          <i class="fa fa-align-justify"></i>
        </div>
      </el-col>
      <el-col :span="4" class="userinfo">
        <el-dropdown trigger="hover">
					<span class="el-dropdown-link userinfo-inner">
						{{$store.getters.getLocalUser.userName}}
						<i class="el-icon-caret-bottom"></i>
					</span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item divided @click.native="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-col>
    </el-col>
    <el-col :span="24" class="main">

      <aside :class="collapsed?'menu-collapsed':'menu-expanded'">
        <!--导航菜单-->
        <el-menu :default-active="$route.meta.activeNav || $route.path"
                 class="el-menu-vertical-demo"
                 :collapse="collapsed" unique-opened router
                 :collapse-transition="false"
        >
          <template v-for="item in menuList">
            <AsideItem :item="item" :hasproductchange="hasproductchange"></AsideItem>
          </template>
        </el-menu>
      </aside>

      <section class="content-container">
        <div class="grid-content bg-purple-light">
          <el-col :span="24" class="breadcrumb-container">
            <!--面包屑导航-->
            <Breadcrumb :cMenus="menuList" @lastStep="lastStep"></Breadcrumb>
          </el-col>
          <el-col :span="24" class="content-wrapper">
            <transition name="fade" mode="out-in">
              <router-view></router-view>
            </transition>
          </el-col>
        </div>
      </section>

    </el-col>
    <el-col :span="24" class="footer">
      <p>版权所有：广西数广网安科技有限公司 服务热线：0771-5649880</p>
    </el-col>
  </el-row>
</template>

<script>
  import http from '@/http'
  import {mapState, mapActions} from "vuex";
  import AsideItem from './asideItem.vue'
  import Breadcrumb from './breadcrumb.vue'
  export default {
    data() {
      return {
        sysName: '渠道管理后台',
        collapsed: false,
        sysUserName: '',
        sysUserAvatar: '/static/img/defaultUserImg.jpg',
        form: {
          name: '',
          region: '',
          date1: '',
          date2: '',
          delivery: false,
          type: [],
          resource: '',
          desc: ''
        },
        activePath: '/main.html',
        hasproductchange: 0,
      }
    },
    components: {
      AsideItem,
      Breadcrumb
    },
    computed: {
      ...mapState({
        menuList: state => state.menuList
      })
    },
    created() {
    },
    methods: {
      backPoster() {
        this.$router.push('/pages/myCdkey.html');
      },
      onSubmit() {
        console.log('submit!');
      },
      handleopen() {
        // console.log('handleopen');
      },
      handleclose() {
        //console.log('handleclose');
      },
      handleselect: function (a, b) {
      },
      //退出登录
      logout: function () {
        var _this = this;
        http.post(_this.globalConfig.domain.backstage + "/login/logout", {}, (response) => {
          let result = response.data;
          if (result&&result.success) {
            _this.$router.push('/login.html');
            _this.$store.dispatch('clearLocalUser');
          } else {
            result && _this.$message.error(result.message);
          }
        });
      },
      //折叠导航栏
      collapse: function () {
        this.collapsed = !this.collapsed;
      },
      // 返回上一步
      lastStep: function () {
        this.$router.push('/pages/myProduct.html');
      },
      queryList: function () {
        var _this = this;
        var param = {
          page: 1,
          pageSize: 1
        };
        http.post(
          _this.globalConfig.domain.backstage +
          "/product/swap/log/list", param,
          (response) => {
            let result = response.data;
            if (result.success) {
              _this.hasproductchange = result.data.pageData.listData.length;
            } else {
              _this.$message.error(result.message);
            }
          }
        );
      }
    },
    mounted() {
      this.queryList();
      var user = JSON.parse(sessionStorage.getItem('user'));
      if (user) {
        this.sysUserName = user.realname || '';
        if (user.avatar) {
          this.sysUserAvatar = user.avatar || '';
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  /deep/ .el-menu-item-group__title {
    padding: 0;
  }

  /deep/ .el-breadcrumb__item {
    display: flex;
    align-items: center;
    line-height: 26px;
    height: 26px;
  }

  .backW {
    cursor: pointer;

    &:hover {
      color: #00B1FF;
    }
  }

  .container {
    position: absolute;
    top: 0px;
    bottom: 0px;
    width: 100%;

    $header-height: 70px;

    .header {
      height: $header-height;
      line-height: $header-height;
      background: $color-primary;
      color: #fff;

      .userinfo {
        text-align: right;
        padding-right: 35px;
        float: right;

        .userinfo-inner {
          cursor: pointer;
          color: #fff;

          img {
            width: 40px;
            height: 40px;
            border-radius: 20px;
            margin: 10px 0px 10px 10px;
            float: right;
          }
        }
      }

      .logo {
        //width:230px;
        height: $header-height;
        font-size: 22px;
        // border-color: rgba(238, 241, 146, 0.3);
        border-color: transparent;
        border-right-width: 1px;
        border-right-style: solid;

        img {
          /*width: 100%;*/
          height: $header-height;
        }

        .txt {
          color: #fff;
        }
      }

      .logo-expand {
        width: 230px;
        padding-left: 10px;
        padding-right: 10px;
      }

      .logo-collapse {
        width: 65px
      }

      .tools {
        padding: 0px 23px;
        width: 14px;
        height: $header-height;
        line-height: $header-height;
        cursor: pointer;
      }
    }

    .footer {
      text-align: center;
      width: 100%;
      height: 0.2rem;
      background: #133147;
      position: fixed;
      bottom: 0;
      z-index: 9999;

      p {

        height: 0.2rem;
        font-size: 14px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        line-height: 0.2rem;
        color: #FFFFFF;
        opacity: 0.65;

      }
    }

    .main {
      display: flex;
      // background: #324057;
      position: absolute;
      top: $header-height;
      bottom: 26px;
      overflow: hidden;

      /deep/ aside {
        flex: 0 0 230px;
        width: 230px;

        // position: absolute;
        // top: 0px;
        // bottom: 0px;
        .el-menu {
          height: 100%;
          border-right: none;
          box-shadow: 5px 0px 16px rgba(0, 0, 0, 0.02);

          .iconfont {
            font-size: 15px;
            margin-right: 10px;
          }

          .indexIcon, .productIcon, .cdkeyIcon, .clientIcon, .earningsIcon, .serveIcon {
            display: inline-block;
            width: 20px;
            height: 20px;
          }

          .indexIcon {
            background: url("../../../static/img/index.png") no-repeat;
            background-size: 100% 100%;
          }

          .productIcon {
            background: url("../../../static/img/product.png") no-repeat;
            background-size: 100% 100%;
          }

          .cdkeyIcon {
            background: url("../../../static/img/cdkey.png") no-repeat;
            background-size: 100% 100%;
          }

          .clientIcon {
            background: url("../../../static/img/client.png") no-repeat;
            background-size: 100% 100%;
          }

          .earningsIcon {
            background: url("../../../static/img/earnings.png") no-repeat;
            background-size: 100% 100%;
          }

          .serveIcon {
            background: url("../../../static/img/serve.png") no-repeat;
            background-size: 100% 100%;
          }



          .el-menu-item {
            color: #022F4A;
            font-size: 16px;
            border-right: 2px solid #FFFFFF;

          }

          .el-menu-item.is-active {
            background: rgba(230, 248, 255, 1);
            color: rgba(0, 177, 255, 1);
            border-right: 2px solid #00B1FF;

            .indexIcon {
              background: url("../../../static/img/indexActive.png") no-repeat;
              background-size: 100% 100%;
            }

            .productIcon {
              background: url("../../../static/img/productActive.png") no-repeat;
              background-size: 100% 100%;
            }

            .cdkeyIcon {
              background: url("../../../static/img/cdkeyActive.png") no-repeat;
              background-size: 100% 100%;
            }

            .clientIcon {
              background: url("../../../static/img/clientActive.png") no-repeat;
              background-size: 100% 100%;
            }

            .earningsIcon {
              background: url("../../../static/img/earningsActive.png") no-repeat;
              background-size: 100% 100%;
            }

            .serveIcon {
              background: url("../../../static/img/serveActive.png") no-repeat;
              background-size: 100% 100%;
            }
          }
        }

        .collapsed {
          width: 60px;

          .item {
            position: relative;
          }

          .submenu {
            position: absolute;
            top: 0px;
            left: 60px;
            z-index: 99999;
            height: auto;
            display: none;
          }

        }
      }

      /deep/ .menu-collapsed {
        flex: 0 0 60px;
        width: 60px;
        .el-submenu__title{
          span{
            display: none;
          }
        }
      }

      .menu-expanded {
        flex: 0 0 230px;
        width: 230px;
      }

      .content-container {
        background: #F8F8F8;
        flex: auto;
        // position: absolute;
        // right: 0px;
        // top: 0px;
        // bottom: 0px;
        // left: 230px;
        overflow-y: auto;
        padding: 20px 30px 30px 30px;

        .breadcrumb-container {
          color: #022F4A;
          font-size: 14px;
          margin-bottom: 15px;
          padding: 0 0 10px 0;
          border-bottom: 1px solid #EEEEEE;

          .title {
            text-align: left;
            float: left;
            color: #475669;
          }

          .breadcrumb-inner {
            float: left;
          }
        }

        .content-wrapper {
          // background-color: #fff;
          box-sizing: border-box;
          width: 100%;
        }
      }

      .el-menu-vertical-demo:not(.el-menu--collapse) {
        width: 229px;
        min-height: 400px;
        text-align: left;

        .el-menu-item-vertical {
          margin-left: 10px;
        }
      }

    }
  }


  /deep/ .el-breadcrumb__inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }

</style>



// WEBPACK FOOTER //
// src/components/layout/MainLayout.vue